var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGreenMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.009,
    x2: 30.605,
    xlinkHref: "#lg1",
    y1: 460.162,
    y2: 408.159
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.64,
    x2: 396.876,
    xlinkHref: "#lg1",
    y1: 188.046,
    y2: 476.904
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 354.999,
    y2: 438.149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1472,
    stopColor: "#f3f8fc",
    stopOpacity: 0.147
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4115,
    stopColor: "#d4e4f4",
    stopOpacity: 0.412
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7598,
    stopColor: "#a2c4e8",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.19,
    x2: 354.914,
    y1: 280.703,
    y2: 730.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.905,
    x2: 84.883,
    y1: 327.093,
    y2: 123.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ade194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ca44"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.021,
    x2: 407.518,
    xlinkHref: "#lg2",
    y1: 295.658,
    y2: 441.151
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68ca44",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47a920"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 380,
    x2: 380,
    xlinkHref: "#lg3",
    y1: 353.999,
    y2: 427.026
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.674,
    x2: 126.945,
    xlinkHref: "#lg2",
    y1: 238.363,
    y2: 364.912
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.435,
    x2: 314.435,
    xlinkHref: "#lg2",
    y1: 105.791,
    y2: 222.791
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.808,
    x2: 143.468,
    xlinkHref: "#lg3",
    y1: 225.525,
    y2: 143.185
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.905,
    x2: 165.905,
    y1: 154.093,
    y2: 204.093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.829,
    x2: 104.48,
    xlinkHref: "#lg3",
    y1: 307.17,
    y2: 220.82
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.785,
    x2: 434.84,
    xlinkHref: "#lg3",
    y1: 387.424,
    y2: 356.787
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.981,
    x2: 456.333,
    y1: 277.481,
    y2: 277.481
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.843,
    x2: 437.067,
    y1: 339.487,
    y2: 358.711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m71.133 465.591c0 12.508-11.594 21.822-23.793 19.064-20.676-4.674-47.335-16.527-47.335-46.579 0-39.283 31.845-71.128 71.128-71.128z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.873 176.488-.007.007c-9.503 9.507-9.502 24.918.004 34.424 4.565 4.565 7.13 10.757 7.13 17.214v180.947c0 16.011-12.979 28.99-28.99 28.99h-148.031c-4.037 0-7.751-2.206-9.682-5.752-3.594-6.599-12.591-7.748-17.728-2.264l-4.242 4.528c-2.084 2.225-4.997 3.487-8.046 3.487h-60.341c-41.86 0-81.29-18.12-109.92-48.66-.52-.55-1.05-1.1-1.59-1.63-6.86-6.86-15.12-12.33-24.31-15.93-8.04-3.16-16.81-4.91-25.98-4.91-19.64 0-37.43 7.97-50.3 20.84-12.88 12.88-20.84 30.66-20.84 50.29v-341.02c0-39.38 31.55-72.08 70.93-72.19 19.72-.06 37.58 7.91 50.5 20.83.1.1.2.2.3.29 19.278 19.515 44.31 32.068 71.194 35.399 2.938.364 5.551 2.041 7.061 4.588l.195.329c3.598 6.071 12.322 6.244 16.16.322 1.753-2.705 4.757-4.338 7.98-4.338h129.875c2.223 0 4.326 1.007 5.72 2.738l10.25 12.732c2.976 3.697 8.625 3.642 11.529-.113 3.087-3.993 9.19-3.753 11.953.471l3.452 5.275c3.287 5.024 10.886 4.194 13.012-1.421l5.655-14.939c1.081-2.855 3.815-4.743 6.867-4.743h58.378c16.011 0 28.99 12.979 28.99 28.99v48.009c-.001 6.455-2.564 12.645-7.128 17.21z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 279.499v129.58c0 16.011-12.979 28.99-28.99 28.99h-148.031c-4.037 0-7.751-2.206-9.682-5.752-3.594-6.599-12.591-7.748-17.728-2.264l-4.242 4.528c-2.084 2.225-4.997 3.487-8.046 3.487h-60.341c-41.86 0-81.29-18.12-109.92-48.66-.52-.55-1.05-1.1-1.59-1.63-6.86-6.86-15.12-12.33-24.31-15.93-8.04-3.16-16.81-4.91-25.98-4.91-19.64 0-37.43 7.97-50.3 20.84-12.88 12.881-20.84 30.661-20.84 50.291v-158.57z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m472 121.402 6 47.321v163.572l-6 63.57c0 8.59-.964 8.553-9.553 8.553h-129.467c-4.04 0-7.75-2.2-9.68-5.75-2.05-3.76-5.86-5.75-9.7-5.75-2.9 0-5.82 1.13-8.03 3.49l-4.246 4.527c-2.085 2.223-4.996 3.483-8.044 3.483l-11.25 7h-49.09c-41.86 0-81.29-18.12-109.92-48.66-.52-.55-1.05-1.1-1.59-1.63-.835-.835-1.691-1.649-2.566-2.442-6.318-5.722-13.672-16.326-21.744-19.488-8.04-3.16-16.81-4.91-25.98-4.91-5.714 0-11.271.675-16.594 1.947-9.697 2.319-11.976.8-11.976-9.17l-7-82.103v-177.176c0-6.391 3.911-12.128 9.854-14.479 7.902-3.127 16.497-4.857 25.506-4.878 19.72-.06 37.58 7.91 50.5 20.83.1.1.2.2.3.29 19.28 19.51 44.31 39.07 71.19 42.4 2.94.36 5.56 1.04 7.06 3.59l.2 1.32c3.6 6.08 12.32 6.25 16.16.33.88-1.35 2.06-2.44 3.44-3.19 1.37-.74 2.93-1.15 4.54-1.15h129.87c2.23 0 4.33 1.01 5.72 2.74l10.25 12.73c2.98 3.7 8.63 3.64 11.53-.11 1.48-1.91 3.65-2.86 5.81-2.86 2.35 0 4.71 1.12 6.15 3.33l3.45 5.27c3.28 5.03 10.88 4.2 13.01-1.42l5.65-14.94c1.09-2.85 3.82-4.74 6.87-4.74h39.817c8.589 0 9.553-.037 9.553 8.553z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.969 436.651-307.739-307.739-91.506 91.506 212.325 212.325 2.52-2.69c5.137-5.483 14.134-4.334 17.728 2.264 1.931 3.545 5.645 5.752 9.682 5.752h148.031c3.127 0 6.136-.501 8.959-1.418z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.324 407.935 4.246-4.526c2.21-2.36 5.13-3.49 8.03-3.49 3.84 0 7.65 1.99 9.7 5.75 1.93 3.55 5.64 5.75 9.68 5.75h129.467c8.59 0 15.553-6.964 15.553-15.553v-63.77c0-16.412-13.304-29.716-29.716-29.716-11.762 0-23.099-4.398-31.784-12.331-8.685-7.932-20.022-12.331-31.784-12.331-25.491 0-49.939 10.126-67.964 28.151l-1.51 1.51c-7.198 7.198-11.242 16.961-11.242 27.141 0 7.683-4.227 14.743-11 18.371-6.773 3.628-11 10.688-11 18.371v40.156h11.28c3.048.001 5.959-1.26 8.044-3.483z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.324 407.935 4.246-4.526c2.21-2.36 5.13-3.49 8.03-3.49 3.84 0 7.65 1.99 9.7 5.75 1.93 3.55 5.64 5.75 9.68 5.75h129.467c8.59 0 15.553-6.964 15.553-15.553v-63.77c0-16.412-13.304-29.716-29.716-29.716-11.762 0-23.099-4.398-31.784-12.331-8.685-7.932-20.022-12.331-31.784-12.331-25.491 0-49.939 10.126-67.964 28.151l-1.51 1.51c-7.198 7.198-11.242 16.961-11.242 27.141 0 7.683-4.227 14.743-11 18.371-6.773 3.628-11 10.688-11 18.371v40.156h11.28c3.048.001 5.959-1.26 8.044-3.483z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.275 357.82c2.272-1.481 4.914-2.254 7.62-2.437 27.645-1.868 49.491-24.885 49.491-53.004 0-29.341-23.786-53.126-53.126-53.126-.331 0-.661.003-.99.009-6.874.128-13.604-1.657-19.667-4.899-9.976-5.336-21.371-8.364-33.476-8.364-12.545 0-24.324 3.26-34.556 8.96v82.107c0 9.971 9.278 17.489 18.975 15.17 5.324-1.273 10.881-1.947 16.595-1.947 9.17 0 17.94 1.75 25.98 4.91 8.117 3.18 15.505 7.823 21.847 13.589.284-.27.757-.61 1.307-.968z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.314 189.055c0-12.366 10.024-22.39 22.39-22.39 12.366 0 22.39 10.024 22.39 22.39v30.562c0 6.599 2.622 12.928 7.288 17.595 9.717 9.717 25.472 9.717 35.19 0 19.353-19.354 45.602-30.226 72.972-30.226h5.099c5.198 0 9.411 4.213 9.411 9.411 0 16.086 13.04 29.126 29.126 29.126h42.326c20.818 0 40.784-8.27 55.504-22.991 14.72-14.721 22.99-34.687 22.99-55.505v-45.625c0-8.59-6.964-15.553-15.553-15.553h-39.817c-3.05 0-5.78 1.89-6.87 4.74l-5.65 14.94c-2.13 5.62-9.73 6.45-13.01 1.42l-3.45-5.27c-1.44-2.21-3.8-3.33-6.15-3.33-2.16 0-4.33.95-5.81 2.86-2.9 3.75-8.55 3.81-11.53.11l-10.25-12.73c-1.39-1.73-3.49-2.74-5.72-2.74h-129.87c-1.61 0-3.17.41-4.54 1.15-1.38.75-2.56 1.84-3.44 3.19-3.84 5.92-12.56 5.75-16.16-.33l-.2-.32c-1.5-2.55-4.12-4.23-7.06-4.59-26.88-3.33-51.91-15.89-71.19-35.4-.1-.09-.2-.19-.3-.29-.129-.129-.259-.258-.389-.386-18.595-18.313-50.111-4.87-50.111 21.228 0 21.501 8.541 42.121 23.745 57.325l46.611 46.611c4.438 4.439 12.028 1.295 12.028-4.982z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.23 128.912-53.034 53.035 12.09 12.09c4.439 4.439 12.028 1.295 12.028-4.982 0-12.365 10.024-22.39 22.39-22.39s22.39 10.024 22.39 22.39v30.562c0 6.599 2.622 12.928 7.288 17.595 9.717 9.717 25.472 9.717 35.19 0 8.603-8.603 18.571-15.525 29.391-20.567z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.833 128.912-17.356 17.356-17.355-17.355c-7.842-7.842-20.556-7.842-28.397 0s-7.842 20.556 0 28.397l17.355 17.355-17.355 17.355c-7.842 7.842-7.842 20.556 0 28.397 7.842 7.842 20.556 7.842 28.397 0l17.355-17.355 17.356 17.356c7.842 7.842 20.556 7.842 28.397 0 7.842-7.842 7.842-20.556 0-28.397l-17.356-17.356 17.356-17.356c7.842-7.842 7.842-20.555 0-28.397-7.842-7.841-20.556-7.841-28.397 0z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.186 306.88c.125-1.485.2-2.983.2-4.5 0-29.341-23.786-53.126-53.126-53.126-.331 0-.661.003-.99.009-1.29.024-2.573-.041-3.85-.148z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.95 337.458c-3.016-3.334-7.377-5.43-12.228-5.43-9.103 0-16.483 7.38-16.483 16.483 0 4.851 2.095 9.211 5.43 12.228l50.271 50.271c6.905-1.587 12.06-7.758 12.06-15.145v-19.357z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.465 373.605c-.732 0-1.477-.108-2.213-.335-10.736-3.313-20.374-8.881-28.644-16.55-3.037-2.816-3.216-7.562-.399-10.599 2.815-3.038 7.562-3.217 10.599-.399 6.605 6.125 14.299 10.571 22.866 13.214 3.958 1.222 6.177 5.42 4.956 9.378-.994 3.222-3.961 5.291-7.165 5.291zm44.137-1.552c-3.006 0-5.843-1.819-6.995-4.79-1.497-3.862.42-8.207 4.282-9.705 7.726-2.995 14.643-7.514 20.559-13.429l1.519-1.52c2.93-2.928 7.678-2.928 10.607 0 2.929 2.93 2.929 7.678 0 10.607l-1.52 1.52c-7.4 7.398-16.062 13.053-25.743 16.808-.891.345-1.808.509-2.709.509zm-90.634-52.314c-3.639 0-6.833-2.653-7.403-6.36-.577-3.752-.87-7.586-.871-11.395 0-7.33 1.069-14.593 3.179-21.59 1.195-3.966 5.379-6.214 9.345-5.017 3.966 1.195 6.212 5.379 5.017 9.345-1.686 5.593-2.54 11.399-2.54 17.26.001 3.047.235 6.114.697 9.115.63 4.095-2.179 7.924-6.272 8.554-.389.06-.772.088-1.152.088zm-155.844-38.985c-.916 0-1.846-.169-2.749-.524-12.389-4.886-20.394-16.642-20.394-29.95v-.422c0-4.143 3.358-7.5 7.5-7.5s7.5 3.357 7.5 7.5v.422c0 8.626 5.628 13.918 10.896 15.995 3.854 1.52 5.746 5.875 4.226 9.729-1.164 2.949-3.99 4.75-6.979 4.75zm242.97-16.648c-1.355 0-2.726-.367-3.96-1.136-2.623-1.635-5.068-3.58-7.269-5.781l-15.842-15.841c-2.929-2.93-2.929-7.678 0-10.607 2.931-2.928 7.679-2.928 10.607 0l15.843 15.843c1.395 1.396 2.939 2.625 4.594 3.656 3.516 2.191 4.589 6.817 2.398 10.332-1.421 2.281-3.868 3.534-6.371 3.534zm-204.941-.396c-1.919 0-3.839-.732-5.303-2.196-2.929-2.93-2.929-7.678 0-10.607l21.213-21.213c2.929-2.928 7.678-2.929 10.606.001 2.929 2.929 2.929 7.677 0 10.606l-21.213 21.213c-1.464 1.463-3.384 2.196-5.303 2.196zm246.269-4.638c-1.886 0-3.774-.707-5.232-2.128-2.967-2.89-3.029-7.638-.139-10.605 4.696-4.821 7.282-11.186 7.282-17.922 0-1.128-.074-2.265-.221-3.377-.541-4.106 2.35-7.874 6.456-8.415 4.098-.544 7.874 2.349 8.415 6.456.232 1.76.35 3.555.35 5.336 0 10.668-4.098 20.75-11.538 28.389-1.47 1.508-3.42 2.266-5.373 2.266zm-101.096-5.519c-1.919 0-3.839-.732-5.304-2.196-2.929-2.93-2.929-7.678 0-10.607l21.213-21.213c2.93-2.928 7.678-2.928 10.607 0 2.929 2.93 2.929 7.678 0 10.607l-21.213 21.213c-1.464 1.464-3.384 2.196-5.303 2.196zm5.823-41.451c-1.636 0-3.282-.532-4.662-1.629-7.14-5.677-15.186-9.884-23.914-12.506-3.967-1.191-6.217-5.373-5.025-9.34 1.19-3.968 5.374-6.218 9.34-5.025 10.562 3.172 20.297 8.263 28.934 15.129 3.243 2.578 3.781 7.296 1.204 10.538-1.482 1.863-3.669 2.833-5.877 2.833zm-97.486-.909c-2.255 0-4.485-1.013-5.961-2.942-2.517-3.289-1.892-7.996 1.398-10.514 8.759-6.702 18.585-11.609 29.208-14.585 3.99-1.113 8.128 1.21 9.245 5.198 1.117 3.989-1.21 8.128-5.198 9.245-8.779 2.46-16.9 6.515-24.138 12.054-1.362 1.041-2.965 1.544-4.554 1.544zm145.301-9.971c-2.524 0-4.988-1.274-6.403-3.585-2.163-3.532-1.053-8.149 2.48-10.313 6.376-3.904 13.718-5.968 21.23-5.968 4.85 0 9.608.851 14.144 2.528 3.885 1.438 5.869 5.752 4.432 9.637s-5.749 5.869-9.637 4.432c-2.863-1.06-5.871-1.597-8.938-1.597-4.747 0-9.38 1.301-13.398 3.761-1.223.749-2.574 1.105-3.91 1.105z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.269,
    cy: 347.914,
    fill: "url(#SVGID_15_)",
    r: 16.483
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenMap);
export default __webpack_public_path__ + "static/media/icon-green-map.e4664a6b7326782c1c0cb6f5bd3a77db.svg";
export { ForwardRef as ReactComponent };